import ExamGroupModel from '@/dex-shared/models/ExamGroupModel';
import MaterialModel from '@/dex-shared/models/MaterialModel';

export default {
  examGroupById: (state: any, getters: any) => (examGroupId: number) => {
    const examGroup = state.exam_groups[examGroupId];
    if (examGroup) {
      return new ExamGroupModel(examGroup, getters);
    } else {
      return {};
    }
  },
  allExamGroups: (state: any, getters: any) => {
    return Object.values(state.exam_groups).map(
      (exam_group: any) => new ExamGroupModel(exam_group, getters),
    );
  },
  materialsByExamGroupId: (state: any, getters: any) => (
    examGroupId: number,
  ) => {
    return Object.values(state.materials)
      .map((material: MaterialModel) => new MaterialModel(material, getters))
      .filter(
        (material: MaterialModel) => material.examGroupId === examGroupId,
      );
  },
};
